import Accordion from './components/accordion'
import Animation from './components/animation'
import Cookies from './components/cookies'
import Faq from './components/faq'
import MobileMenu from './components/mobile-menu'
import Modal from './components/modal'
import Navbar from './components/navbar'
import OrphanChars from './components/orphan-chars'
import ScrollToAnchor from './components/scroll-to-anchor'
import Slider1 from './components/slider1'
import Slider2 from './components/slider2'
import SliderSingle from './components/slider-single'
import Filter from './components/filter'

window.addEventListener('DOMContentLoaded', () => {
   new Accordion()
   new Animation()
   new Cookies()
   new Faq()
   new MobileMenu()
   new Modal()
   new Navbar()
   new OrphanChars()
   new ScrollToAnchor()
   new Slider1()
   new Slider2()
   new SliderSingle()
   new Filter();
})



//////////////////
// WEBPACK FOOTER
// ./js/main.js
// module id = 5
// module chunks = 0